import type { CustomerAddress } from '@lib/query/mutations/customer';

import Text from '@modules/common/components/text';
import AddAddress from '../address-card/add-address';
import EditAddress from '../address-card/edit-address';

interface AddressBookProps {
  addresses: CustomerAddress[];
}

const AddressBook: React.FC<AddressBookProps> = ({ addresses }) => {
  return (
    <div className="w-full">
      <div className="mb-8 flex flex-col gap-y-4">
        <Text as="p" variant="2xl-semi" className="font-bold">收件地址</Text>
      </div>
      <div className="mt-4 grid flex-1 grid-cols-2 gap-4 lg:grid-cols-2">
        <AddAddress />
        {addresses.map((address) => {
          return <EditAddress address={address} key={address.id} />;
        })}
      </div>
    </div>
  );
};

export default AddressBook;
